import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, reactive, ref, watch } from 'vue'
import { BKModal } from '@/shared/ui/modals'
import { useImage } from '@/shared/composables/image'
import BKInput from '@/components/AppShared/BKInput.vue'
import BKImage from '@/components/AppShared/BKImage.vue'
import { mdiMagnify, mdiTuneVariant } from '@mdi/js'
import { IOrganizationApiData, IOrganizations } from '@/types/organizations'
import { fetchOrganizationsList } from '@/enitites/organization'


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterEventsDialog',
  emits: ["filterByOrg"],
  setup(__props, { emit }: { emit: ({ (e: 'filterByOrg', value: number[]): void }), expose: any, slots: any, attrs: any }) {

const { getOrgImage } = useImage()



const isShow = ref(false)
const organizationsList = ref<IOrganizations[] | []>([])
const keyword = ref('')
const searchedOrganizations = computed<IOrganizations[] | []>(() =>
  organizationsList.value.filter((org) => org.name.toLowerCase().includes(keyword.value.toLowerCase()))
)

const selectedOrganizationsIds = ref<number[] | []>([])
const isShowAllOrganizations = ref(!selectedOrganizationsIds.value.length)

watch(selectedOrganizationsIds, () => {
  isShowAllOrganizations.value = !selectedOrganizationsIds.value.length
})

function clearSelectedOrganizations() {
  if (!isShowAllOrganizations.value) return
  selectedOrganizationsIds.value = []
  emit('filterByOrg', selectedOrganizationsIds.value)
}

const totalOrgStats = reactive({
  now: 0,
  future: 0,
  past: 0,
})

async function fetchOrganizations() {
  const organizations: IOrganizationApiData = await fetchOrganizationsList({ pageNumber: 0, pageSize: 100, userId: 0 })
  if (!organizations) return
  organizationsList.value = organizations.items
  totalOrgStats.now = organizations.totalCurrent
  totalOrgStats.future = organizations.totalFuture
  totalOrgStats.past = organizations.totalPast
}

onMounted(() => {
  fetchOrganizations()
})

return { __sfc: true,getOrgImage, emit, isShow, organizationsList, keyword, searchedOrganizations, selectedOrganizationsIds, isShowAllOrganizations, clearSelectedOrganizations, totalOrgStats, fetchOrganizations, BKModal, BKInput, BKImage, mdiMagnify, mdiTuneVariant }
}

})